var exports = {
  "CR": "PersonaReactAsModal.module__modalRoot___Um5xWH",
  "Pg": "PersonaReactAsModal.module__emojiPreview___Um5xWH",
  "Ow": "PersonaReactAsModal.module__emojiPreviewImage___Um5xWH",
  "Ze": "PersonaReactAsModal.module__emojiSurrogate___Um5xWH",
  "Mc": "PersonaReactAsModal.module__searchInputWrapper___Um5xWH",
  "qc": "PersonaReactAsModal.module__searchIcon___Um5xWH",
  "Rt": "PersonaReactAsModal.module__searchInput___Um5xWH",
  "jE": "PersonaReactAsModal.module__modalContent___Um5xWH",
  "qI": "PersonaReactAsModal.module__listContainer___Um5xWH",
  "Gf": "PersonaReactAsModal.module__sectionTitle___Um5xWH",
  "kd": "PersonaReactAsModal.module__personaItem___Um5xWH",
  "pC": "PersonaReactAsModal.module__keyboardSelected___Um5xWH",
  "vu": "PersonaReactAsModal.module__active___Um5xWH",
  "ht": "PersonaReactAsModal.module__personaDetails___Um5xWH",
  "vb": "PersonaReactAsModal.module__personaPrimaryRow___Um5xWH",
  "_M": "PersonaReactAsModal.module__personaName___Um5xWH",
  "BN": "PersonaReactAsModal.module__personaPronouns___Um5xWH",
  "J": "PersonaReactAsModal.module__activeCheck___Um5xWH",
  "W$": "PersonaReactAsModal.module__emptyNotice___Um5xWH",
};

module.exports = exports;
